import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AWS, { Credentials } from "aws-sdk";
import ExternalFormHeader from "../../components/DataRequests/ExternalForm/ExternalFormHeader/ExternalFormHeader";
import { GetJSONFileData } from "../../components/s3/DataRequest/GetJSONFileData";
import ExternalFormTable from "../../components/DataRequests/ExternalForm/ExternalFormTable/ExternalFormTable";
import { DataRequestContext } from "../../components/context/DataRequestContext";

/**
 * External form displayed to the unauthenticated user
 */
export default function ExternalForm() {
  const { company, formId } = useParams();
  const {formData, setFormData} = useContext(DataRequestContext);
  const [loading, setLoading] = useState(true);
  const [showCheckboxes, setShowCheckboxes] = useState(false); // show checkboxes for merging data
  const [checkboxState, setCheckboxState] = useState({}); //checkbox for merging data
  const isExternalMember = !(localStorage.getItem("position"));
  
  const S3 = new AWS.S3({
    region: process.env.REACT_APP_REGION,
    credentials: new Credentials({
      accessKeyId: process.env.REACT_APP_ACCESS_ID,
      secretAccessKey: process.env.REACT_APP_ACCESS_KEY
    })
  });

  const handleJSONData = async () => {
    const data = await GetJSONFileData(S3, company, formId);
    if (data) {
      setFormData(data);
console.log(data)
    }
    setLoading(false); 
  };

  // If the page is refreshed, get the data again
  useEffect(() => {
    const fetchData = async () => {
      if (!formData) {
        await handleJSONData();
      }
      setLoading(false); 
    };
    fetchData();
  }, [formId]);

  
  if (loading) {
    return <div>Loading...</div>;
  }
  if (!formData || !formData.FileData) {
    return <div>No data available</div>;
  }
  return (
    <div>
      {formData && (
        <>
          <ExternalFormHeader 
          formData={formData.FileData} 
          isExternalMember={isExternalMember} 
          showCheckboxes={showCheckboxes} 
          setShowCheckboxes={setShowCheckboxes}
          checkboxState={checkboxState} 
          />
          <ExternalFormTable 
          propertiesData={formData.FileData.PropertiesData} 
          isExternalMember={isExternalMember} 
          showCheckboxes={showCheckboxes} 
          checkboxState={checkboxState} 
          setCheckboxState={setCheckboxState}/>
        </>
      )}
    </div>
  );
}
